import React from 'react';
import Box from 'core/ui/Box';
import DocSection from './DocSection';

const DocSections = ({ form }) => {
  const addOption = (sec, text) => {
    if (!text) {
      return;
    }
    const currentOptions = sec?.options || [];
    form.changeSection(sec, 'options', [...currentOptions, text]);
  };

  const removeOption = (sec, item) => {
    form.changeSection(
      sec,
      'options',
      sec?.options.filter((x) => x !== item),
    );
  };

  const reorderSection = (sec, index) => {
    const ar = [];

    const newIndex = index > 0 ? index - 1 : 0;

    form.sections.forEach((section, idx) => {
      if (section.id === sec.id) {
        ar.push({ ...section, showOrder: newIndex });
      } else if (idx >= newIndex) {
        ar.push({ ...section, showOrder: idx + 1 });
      } else {
        ar.push({ ...section, showOrder: idx });
      }
    });

    form.setSections(ar);
  };

  return (
    <>
      <Box>
        {form?.sections?.map((sec, index) => (
          <Box key={sec?.id || index}>
            <DocSection
              sec={sec}
              index={index}
              form={form}
              actions={{ removeOption, addOption, reorderSection }}
            />
          </Box>
        ))}
      </Box>
    </>
  );
};

export default DocSections;
